import {FeatureNs} from '@shared/types/feature.namespace';

export namespace IntegrationNs {

    export enum IntegrationTypeEnums {
        JIRA = 'JIRA',
        TRELLO = 'TRELLO',
        AZURE = 'AZURE',
        PIVOTAL = 'PIVOTAL',
        SLACK = 'SLACK',
        FIGMA = 'FIGMA',
        CURSOR = 'CURSOR',
        GITHUBCOPILOT = 'GITHUBCOPILOT',
        CLAUDE = 'CLAUDE',
        GOOGLE_DRIVE = 'GOOGLE_DRIVE'
    }

    export interface ConfirmAuthenticationRequest {
        authCode: string,
        state: string,
        integrationType: IntegrationTypeEnums
    }

    export interface StoreAzureCredentialsRequest {
        code: string
        organization: string
        pat: string
    }

    export interface IntegrationType {
        type: IntegrationTypeEnums
        title: string
        subtitle: string
        content: string
        icon: string
        count: number
        domain: string
        /** Capability tag shown on the connection card (e.g. "Two-way sync", "Import"). */
        badge?: string
        /** When set, the connection card shows a "Manage" link routing to this settings… */
        detailPath?: string
    }

    export interface ProjectIntegrationInfo {
        projectIntegrationId: number,
        fpProjectName: string
        intProjectName: string
        intProjectKey: string
        createdBy: string
        createDate: string
    }

    export interface IntegrationInfo {
        integrationType: IntegrationTypeEnums,
        integratedWorkspace: string,
        integrationCreatedBy: string,
        integrationCreateDate: string,
        integratedProjectCount: number,
        integratedProjects: ProjectIntegrationInfo[],
        isActive: boolean
    }

    export interface IntegrationInfoRequest {
        workspaceId: string,
        integrationType: IntegrationTypeEnums
    }

    export interface ProjectIntegrationRequest extends IntegrationInfoRequest {
        projectKey: string,
        msProjectId: string,
        issueMatching: any,
        importNow: boolean,
        synchType: string,
        importOption: string,
    }

    export interface ChangeSyncTypeRequest extends IntegrationInfoRequest {
        projectId: string,
        syncType: string,
    }

    export interface ProjectIntegrationReimportRequest extends IntegrationInfoRequest {
        projectId: string,
        importType: 'IMPORT_NEW' | 'UPDATE_ALL'
    }

    export interface RemoveIntegrationRequest extends IntegrationInfoRequest {
        integrationId: number,
        intProjectKey: string,
    }

    export interface GetIssueTypeRequest extends IntegrationInfoRequest {
        projectKey: string,
    }

    export interface IntIssueField {
        key: string,
        name: string,
        type: string,
        required: boolean,
    }

    export interface IntIssueType {
        id: string,
        name: string,
        description: string,
        iconUrl: string,
        hierarchyLevel: number,
        isSubTask: boolean,
        availableFields: IntIssueField[],
    }

    export interface IntIssueTypeMapping {
        featureType: FeatureNs.FeatureTypeEnums,
        issueTypeId: string,
        issueTypeName: string,
    }

    export interface FigmaNode {
        id: string,
        name: string,
        url: string,
    }

    export interface FigmaFrame extends FigmaNode {
        loading: boolean
    }

    export interface BaseFigmaRequest {
        workspaceId: string,
        projectId?: string,
        fileKey: string
    }

    export interface GetChildNodesRequest extends BaseFigmaRequest {
        nodeId: string
    }

    export interface FigmaImageUploadRequest extends BaseFigmaRequest {
        parentId: string | null,
        frames: FigmaFrame[],
        hidden?: boolean,
        screenId?: string,
        /** The feature these frames are for, when the import came from one. */
        relatedFeatureId?: string
    }

}
